/*
 * © Copyright 2014 - 2022 Micro Focus or one of its affiliates.
 *
 * The only warranties for products and services of Micro Focus and its affiliates and licensors ("Micro Focus") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Micro Focus shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import React from 'react';
import {STATUS_TYPE,createToast} from '../../../../ux/ux';
import * as facial from '../../../../api/devices/facial-device.api';
import t from '../../../../i18n/locale-keys';
import FacialVideo from '../../method-authenticators/FacialVideo';

const FACIAL_VIDEO_KEY = 'Test';

class HANISFaceTest extends React.PureComponent {
    constructor(props) {
        super(props);

        this.componentIsMounted = false;
        this.state = {
            faceImg: null,
            showFace: false,
            imgSrc: '',
            remainingImages: [],
            capturePercentage: 0,
            showCaptureProgressBar: false
        };

        this.props.setTestButtonAvailability(false);
    }

    componentDidMount() {
        this.componentIsMounted = true;
        facial.stopCapture();
        this.captureFaceAndSubmitAuth();
    }

    componentWillUnmount() {
        this.componentIsMounted = false;
        facial.stopCapture();
    }

    calculatePercetnage(policyData){
        let percentage = 100;
        const { livenessDetection, maxLivenessAttempts } = policyData;
        if (livenessDetection && maxLivenessAttempts)  
        percentage = this.state.capturePercentage + (100 / maxLivenessAttempts);
        this.setState({ capturePercentage: percentage });
    }

    async captureHanisFace(imageParams, policyData) {
        let images = [];
        const hanisCallbacks = { startCapture: this.startCapture };
        const capture = async () => {
            const capturedImage = await facial.captureFace(FACIAL_VIDEO_KEY, this.captureFaceCallBack, null, imageParams, hanisCallbacks);
            this.props.showStatus(t.faceDetected(), STATUS_TYPE.INFO);
            images.push(capturedImage);
            this.calculatePercetnage(policyData);
            // If multiple capture requires, make multiple capture calls
            if (policyData.livenessDetection) {
                if (images.length < policyData.maxLivenessAttempts) {
                    await capture();
                }

            }
        }
        await capture();
        return images;
    }

    captureFaceAndSubmitAuth() {
        this.props.showStatus(t.faceDetecting(), STATUS_TYPE.INFO);

        this.setState({
            showFace: true
        });

        const policyData = this.props.policies.hanisFaceMethod.data;
        const imageParams = {'height':'1024'}; // Recommended Aspect ratio

        this.captureHanisFace(imageParams, policyData).then((capturedImages) => {
            facial.stopCapture();
            this.doTestHanisLogon(capturedImages);
        }).catch((error) => {
            console.error("Error Occurred in the FaceCapture:", error);
            facial.stopCapture();
            if (error.status === 'timeout') {
                this.props.markTestComplete(false, t.facialTimeout());
            }
            else {
                this.props.markTestComplete(false, error);
            }

        });
    }

    testNextHanisFace() {
        if (this.props.policies.hanisFaceMethod.data.livenessDetection) {
            const capturedImages = this.state.remainingImages;
            if (capturedImages && capturedImages.length > 0) {
                this.doTestHanisLogon(capturedImages);
            }
            else {
                console.log("No More Images to process!!!");
                createToast({ type: STATUS_TYPE.INFO, description: t.hanisTestLogonOverReached() });
            }
        }
    }

    doTestHanisLogon(capturedImages){
        this.setState({
            remainingImages: capturedImages.slice(1),
            showFace: false,
            faceImg: capturedImages[0]
        }, () => {
            console.log("HANIS STATE", this.state);
            this.props.showStatus(t.captureComplete(), STATUS_TYPE.INFO);
            this.props.doTestLogon({ faceImg: this.state.faceImg }).then((response) => {
                console.log("Test Logon Response:", response);
            }).catch(error => {
                facial.stopCapture();
                console.error("Error Occurred in TestLogon call:", error);
            });
        });
    }

    captureFaceCallBack = (data) => {
        if (this.componentIsMounted) {
            this.setState(data);
        }
    };

    startCapture = () => {
        if (!this.state.showCaptureProgressBar) {
            this.setState({ showCaptureProgressBar: true });
        }
    }

    render() {
        const {faceImg, showFace, imgSrc, showCaptureProgressBar} = this.state;
        return (
            <div>
                <FacialVideo
                    captureDone={!!faceImg}
                    facialVideoKey={FACIAL_VIDEO_KEY}
                    imgSrc={imgSrc}
                    showFace={showFace}
                    width="548"
                    height="325"
                />
                {showCaptureProgressBar && <div class='progress-bar'>
                    <span>{t.capturing()} {Math.round(this.state.capturePercentage)}%</span>
                    <progress id="file" value={this.state.capturePercentage} max="100"></progress>
                </div>}
            </div>
        );
    }
}

export default HANISFaceTest;
